module.exports = __webpack_public_path__ + "img/建材.654ab595.png";